module.exports = __webpack_public_path__ + "static/kalabro-avatar-5ba817afa006cc15b18e5f38a503fe01.jpg";